import React from 'react';
import { useTranslation } from 'react-i18next';

import Title from '../../../components/common/title';
import {
  LIVESTOCK_SUMMARY_INDEX,
} from '../../../router/routes';

import {
  Tab,
  TabContainer,
  TabContents,
  TabLink,
  TabNavigation,
  useTab,
} from '../../../components/common/tabs/tab-container';

import MilkProduction from './milk-production';

export enum TabKey {
  DAIRY = 'dairy',
  SHEEPS = 'sheeps',
}

export default function Summary() {
  const { t } = useTranslation();
  const [currentTab, setTab] = useTab(LIVESTOCK_SUMMARY_INDEX, [
    'tab',
    'farmId',
  ]);

  return (
    <>
      <Title title={t('pages.livestock.summary.title')} />
      <TabContainer
        selectedTabKey={currentTab}
        setTab={setTab}
        tabNavigation={
          <TabNavigation>
            <TabLink tabKey={TabKey.DAIRY}>
              {t('pages.livestock.summary.section.dairy')}
            </TabLink>
            <TabLink tabKey={TabKey.SHEEPS}>
              {t('pages.livestock.summary.section.sheeps')}
            </TabLink>
          </TabNavigation>
        }
        tabContents={
          <TabContents>
            <Tab tabKey={TabKey.DAIRY}>
              <MilkProduction />
            </Tab>
            <Tab tabKey={TabKey.SHEEPS}>

            </Tab>
          </TabContents>
        }
      />
    </>
  );
}
